import $ from "jquery";

const logoScroll = () => {
  $(window).on("scroll", function () {
    const scroll = $(window).scrollTop();
    const el = {
      logo: ".main-header .logo-header",
    };

    if ($(el.logo).length === 0) return;

    const isScroll = $(el.logo).data("is_scroll");
    if (!isScroll) return;

    if (scroll >= 10) {
      $(el.logo).addClass("scroll");
    } else {
      $(el.logo).removeClass("scroll");
    }
  });
};

try {
  logoScroll();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
